module.exports = __webpack_public_path__ + "img/icon_password_setting.9578b7c2.svg";